import { render, staticRenderFns } from "./type120.vue?vue&type=template&id=09d69699&scoped=true"
import script from "./type120.vue?vue&type=script&lang=js"
export * from "./type120.vue?vue&type=script&lang=js"
import style0 from "./type120.vue?vue&type=style&index=0&id=09d69699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d69699",
  null
  
)

export default component.exports